import { logger } from '@/services/logger';

export const isTransparentImage = (image: HTMLImageElement): boolean => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    try {
        if (!image.width || !image.height || !ctx) {
            return false;
        }

        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        const imageData = Array.from(ctx.getImageData(0, 0, canvas.width, canvas.height).data);

        for (let i = 3; i < imageData.length; i += 4) {
            if (imageData[i] < 255) {
                return true;
            }
        }

        return false;
    } catch (error) {
        logger.error('Error checking transparency:', { image: image.src, error });
        return false;
    } finally {
        canvas.remove();
    }
};
